import { render } from "./PickupComponent.vue?vue&type=template&id=71c50108&scoped=true"
import script from "./PickupComponent.vue?vue&type=script&lang=js"
export * from "./PickupComponent.vue?vue&type=script&lang=js"

import "./PickupComponent.vue?vue&type=style&index=0&id=71c50108&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-partner-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c50108"]])

export default __exports__